import { render, staticRenderFns } from "./table-ad-expand.vue?vue&type=template&id=64595764&"
import script from "./table-ad-expand.vue?vue&type=script&lang=js&"
export * from "./table-ad-expand.vue?vue&type=script&lang=js&"
import style0 from "./table-ad-expand.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports